import * as Types from "src/Constants/Types";

export const setIsLoading = (value: boolean) => ({ type: Types.SET_IS_LOADING, value });

export const setIsMobile = (value: boolean) => ({ type: Types.SET_IS_MOBILE, value });

export const setIsSidebarOpen = (value: boolean) => ({ type: Types.SET_IS_SIDEBAR_OPEN, value });
